import { createSelector, createSlice } from '@reduxjs/toolkit';
import { getCareer, getVacancies, getVacancy } from 'api/Career';
import { fetchWithLanguage } from 'store/helpers';

export const fetchCareer = fetchWithLanguage('fetchCareer', getCareer);
export const fetchVacancies = fetchWithLanguage('fetchVacancies', getVacancies);
export const fetchVacancy = fetchWithLanguage('fetchVacancy', getVacancy);

const careerSlice = createSlice({
    name: 'careerSlice',
    initialState: {
        career: {},
        vacanciesList: [],
        vacanciesContent: {},
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchVacancies.fulfilled, (state, action) => {
                state.vacanciesList = action.payload;
            })
            .addCase(fetchCareer.fulfilled, (state, action) => {
                state.career = action.payload;
            })
            .addCase(fetchVacancy.fulfilled, (state, action) => {
                const newVacancyKey = action.payload.data.slug;

                const newVacancy = {
                    [newVacancyKey]: action.payload.data,
                };

                state.vacanciesContent = {
                    ...state.vacanciesContent,
                    ...newVacancy,
                };
            });
    },
});

export const selectCareerPage = createSelector([state => state.careerState.career], career => career.data || {});

export const selectVacanciesContent = createSelector([state => state.careerState.vacanciesContent], data => data);

export default careerSlice.reducer;
